import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EstensaSettingsType } from '../search-page/search-param.model';
import { ColDef } from 'ag-grid-community';
import {
    ColorConfiguration,
    MenuEntryChangeEventType,
    SettingMenuEmitEventType,
    SettingsConfiguration,
    SettingsDataValues,
    SizeConfiguration,
} from './types';
import { parseSettingsDataValues } from './helpers';
import { MatMenu } from '@angular/material/menu';

@Component({
    selector: 'se-search-settings',
    templateUrl: './se-search-settings.component.html',
    styleUrls: ['./se-search-settings.component.scss'],
})
export class SeSearchSettingsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    protected readonly EstensaSettingsType = EstensaSettingsType;

    @Input()
    settingsConfig: SettingsConfiguration = [];

    @Input() confColor: ColorConfiguration = 'blue';

    @Input() sizeConfiguration: SizeConfiguration = 'medium';

    _settingsDataValuesList: SettingsDataValues[] = [];

    @Input()
    set settingsDataValuesList(settingsValues: SettingsDataValues[]) {
        this._settingsDataValuesList = this.settingsConfig.map((settingsConfig, idx) => {
            return parseSettingsDataValues(settingsValues[idx] || {}, settingsConfig.settings);
        });
    }

    get settingsDataValuesList(): SettingsDataValues[] {
        return this._settingsDataValuesList;
    }

    @Input() extraButtons: { label: string; triggerFor: MatMenu }[] = [];

    /**
     * callback ogni volta che cambia un valore in uno dei sottomenu.
     * rimane compito del componente padre applicare le opportune modifiche ai valori
     * es se la modifica di uno dei singleSettings implica che debba cambiare anche il valore di un'altro e` una logica che va implementata in questa callback
     * @param subMenuName nome del menu in cui e avvenuta una modifica
     * @param settingName nome del setting modificato
     * @param settingConfigChanged lista dei config modificati. in genere uno solo perche la callback viene chiamata onchange sul singolo input
     */
    @Output()
    configEntryChanged = new EventEmitter<MenuEntryChangeEventType>();

    settingType = EstensaSettingsType;

    @Input()
    isCurrentUserAuthorized!: () => boolean;

    @Input()
    showSaveSettingsUser: boolean = true;
    @Input()
    showSaveSettingsSite: boolean = true;
    @Input()
    showResetDefaultSettingsUser: boolean = true;
    @Input()
    showResetDefaultSettingsSite: boolean = true;
    @Input()
    settingsTooltip: string = 'ResultGridSettings';

    @Input()
    onSaveSettings!: (settingsType: EstensaSettingsType) => void;
    @Input()
    onResetDefaultSettings!: (settingsType: EstensaSettingsType) => void;

    handleSubMenuEvent = ($event: SettingMenuEmitEventType, menuName: string) => {
        const { settingName, value, propName } = $event;
        this.configEntryChanged.emit({ propName, menuName, settingName, value });
    };
}
